import { defineStore } from 'pinia';
import { ref } from 'vue';

let _nextId = 1;

export const useToastStore = defineStore('toast', () => {
    const toasts = ref([]);

    function add(message, type = 'info', duration = 3500) {
        const id = _nextId++;
        toasts.value.push({ id, message, type });
        setTimeout(() => remove(id), duration);
        return id;
    }

    function success(message, duration)  { return add(message, 'success', duration); }
    function error(message, duration)    { return add(message, 'error', duration ?? 5000); }
    function warning(message, duration)  { return add(message, 'warning', duration); }
    function info(message, duration)     { return add(message, 'info', duration); }

    function remove(id) {
        toasts.value = toasts.value.filter(t => t.id !== id);
    }

    return { toasts, success, error, warning, info, remove };
});
